document.addEventListener('DOMContentLoaded', function () {
  const toggles = document.querySelectorAll('.collapsible__toggle');

  if (!toggles.length) return;

  toggles.forEach(function (btn) {
    btn.addEventListener('click', function () {
      const wrapper = btn.closest('.collapsible');
      if (!wrapper) return;

      const content = wrapper.querySelector('.collapsible__content');
      const icon = btn.querySelector('.collapsible__icon');
      const isExpanded = btn.getAttribute('aria-expanded') === 'true';

      btn.setAttribute('aria-expanded', String(!isExpanded));
      wrapper.classList.toggle('is-open', !isExpanded);

      if (!content) return;

      if (!isExpanded) {
        // OPEN
        content.hidden = false;
        const height = content.scrollHeight;
        content.style.maxHeight = height + 'px';
      } else {
        // CLOSE
        content.style.maxHeight = content.scrollHeight + 'px';
        requestAnimationFrame(function () {
          content.style.maxHeight = '0px';
        });
        window.setTimeout(function () {
          content.hidden = true;
        }, 300);
      }

      if (icon && icon.querySelector('svg')) {
        icon.classList.toggle('is-rotated', !isExpanded);
      }
    });
  });
});
